export interface AssistanceAuxiliaryEquipmentDTO {
    erpId: string;
    description: string;
    serialNumber: string;
  }
  
  export class AssistanceAuxiliaryEquipmentDTO implements AssistanceAuxiliaryEquipmentDTO {
    constructor(
      public erpId: string,
      public description: string,
      public serialNumber: string
    ) {}
  }